import { render, staticRenderFns } from "./CustomerEditDialog.vue?vue&type=template&id=fe167700&scoped=true"
import script from "./CustomerEditDialog.vue?vue&type=script&lang=js"
export * from "./CustomerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditDialog.vue?vue&type=style&index=0&id=fe167700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe167700",
  null
  
)

export default component.exports